import React from 'react';

import { useMutation } from '@tanstack/react-query';

import Button from '../../../../Button';

import downloadDocument from '../../../../../helpers/downloadDocument';
import ReportService from '../../../../../services/ReportService';
import { useUiContext } from '../../../../../context/UiContext';

export default function Reports({ loanId }) {
  const { showToast } = useUiContext();

  const { mutate: downloadReport, isPending } = useMutation({
    mutationFn: async () => {
      const doc = await ReportService.getPaymentHistory(loanId);
      await downloadDocument(doc.id, doc.name);
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <div className="flex justify-between">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
          Payment History Statement
        </h2>
      </div>
      <Button onClick={downloadReport} isSubmitting={isPending}>
        Generate
      </Button>
    </div>
  );
}
